import { Currency } from '@synergy/models';

export const supportedCurrenciesReducer = (state: Currency[] = []) => {
    return state;
};
